"use strict";
/*
 * Created on 05 28 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Utility class for {@link Product product} entity.
 *
 * <strong>
 *     This class contains client dependant stuff. After modules will be refactored (client dependant modules created), it should be moved
 *     from this module (common-be-fe) and changed module imports of all usages.
 * </strong>
 *
 * @author JMe
 */

var ProductUtils =
/*#__PURE__*/
function () {
  function ProductUtils() {
    _classCallCheck(this, ProductUtils);
  }

  _createClass(ProductUtils, null, [{
    key: "goldIdToProductExternalId",

    /**
     * Client dependant method that transforms given GOLD product id to external product id as it is used within this system. If the given
     * value already satisfies the requirements, it return the same value.
     *
     * @param goldId partial external id of product
     * @return created external id
     */
    value: function goldIdToProductExternalId(goldId) {
      // this is quite danger, but it is based on data analysis
      if (goldId.match(/^[a-zA-Z0-9]+:\d$/)) {
        return goldId;
      }

      return "".concat(goldId).concat(ProductUtils.EXTERNAL_ID_SEPARATOR).concat(ProductUtils.EXTERNAL_ID_VARIANT_ID);
    }
    /**
     * Client dependant method that transforms given product external id to GOLD product id.
     *
     * @param externalId external id of product that should be transformed
     * @returns transformed external product id to gold id
     * @throws exception if given external id is not valid product external id
     */

  }, {
    key: "productExternalIdToGoldId",
    value: function productExternalIdToGoldId(externalId) {
      if (externalId.match(/^[a-zA-Z0-9]+:\d$/) === null) {
        throw new Error("Given value ".concat(externalId, " is not valid product external id."));
      }

      var separatorIndex = externalId.lastIndexOf(ProductUtils.EXTERNAL_ID_SEPARATOR);

      if (separatorIndex < 0) {
        // it should be already validated by the regexp but just in case
        throw new Error("Given value ".concat(externalId, " is not valid product external id."));
      }

      return externalId.substring(0, separatorIndex);
    }
  }]);

  return ProductUtils;
}();

exports.ProductUtils = ProductUtils;
/**
 * Separator used within external id product.
 */

ProductUtils.EXTERNAL_ID_SEPARATOR = ':';
/**
 * Default variant id of a product
 */

ProductUtils.EXTERNAL_ID_VARIANT_ID = '1';